import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Map, ChevronRight } from 'lucide-react';

const Sitemap = () => {
  useEffect(() => {
    document.title = 'Site Haritası | akarma';
  }, []);

  const sitemapSections = [
    {
      title: 'Ana Sayfalar',
      links: [
        { title: 'Ana Sayfa', path: '/', description: 'akarma eğitim ve koçluk hizmetleri ana sayfası' },
        { title: 'Hakkında', path: '/hakkinda', description: 'Banu Gökcül ve akarma hakkında detaylı bilgi' },
        { title: 'Hizmetler', path: '/hizmetler', description: 'Sunulan tüm hizmetlerin genel tanıtımı' },
        { title: 'İletişim', path: '/iletisim', description: 'İletişim formu ve iletişim bilgileri' }
      ]
    },
    {
      title: 'Eğitimler',
      links: [
        { title: 'Kurumsal Eğitimler', path: '/kurumsal-egitimler', description: '18 farklı kurumsal eğitim programı' },
        { title: 'Bireysel Eğitimler', path: '/bireysel-egitimler', description: 'Bireysel danışmanlık ve koçluk hizmetleri' }
      ]
    },
    {
      title: 'İçerik',
      links: [
        { title: 'Kitaplar', path: '/kitaplar', description: '4 yayınlanmış liderlik kitabı' },
        { title: 'Makaleler', path: '/makaleler', description: 'Kişisel gelişim ve psikoloji makaleleri' }
      ]
    },
    {
      title: 'Makaleler (Detay)',
      links: [
        { title: 'Zengin olmak mı istiyorsunuz?', path: '/makaleler/zengin-olmak', description: 'Bolluk bilinci ve NLP teknikleri' },
        { title: 'Avatarın Sonbahar Ayılmaları', path: '/makaleler/avatar-sonbahar-ayilmalari', description: 'Otantik benlik ve farkındalık' },
        { title: 'Bilişsel Tedavi', path: '/makaleler/bilissel-tedavi', description: 'Aaron Beck ve düşünce-duygu-davranış döngüsü' }
      ]
    },
    {
      title: 'Yasal',
      links: [
        { title: 'Kullanım Şartları', path: '/kullanim-sartlari', description: 'Web sitesi kullanım koşulları' },
        { title: 'Gizlilik Politikası', path: '/gizlilik', description: 'Kişisel verilerin korunması ve KVKK' },
        { title: 'Site Haritası', path: '/site-haritasi', description: 'Tüm sayfaların listesi' }
      ]
    }
  ];

  return (
    <div className="sitemap pt-24 pb-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <Map size={64} className="mx-auto mb-6" />
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Site Haritası</h1>
            <p className="text-xl opacity-90">akarma.com.tr web sitesinin tüm sayfaları</p>
          </div>
        </div>
      </section>

      {/* Sitemap Content */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {sitemapSections.map((section, index) => (
                <div key={index} className="bg-white rounded-2xl shadow-lg p-8 card-hover">
                  <h2 className="text-2xl font-bold mb-6 text-akarma-blue flex items-center">
                    <ChevronRight size={24} className="mr-2" />
                    {section.title}
                  </h2>
                  <ul className="space-y-4">
                    {section.links.map((link, linkIndex) => (
                      <li key={linkIndex}>
                        <Link
                          to={link.path}
                          className="block p-4 rounded-lg hover:bg-gray-50 transition-colors group"
                        >
                          <div className="flex items-start justify-between">
                            <div className="flex-1">
                              <h3 className="font-semibold text-gray-900 group-hover:text-akarma-blue transition-colors mb-1">
                                {link.title}
                              </h3>
                              <p className="text-sm text-gray-600">{link.description}</p>
                            </div>
                            <ChevronRight size={20} className="text-gray-400 group-hover:text-akarma-blue transition-colors flex-shrink-0 ml-2 mt-1" />
                          </div>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            {/* Additional Info */}
            <div className="mt-12 bg-gradient-to-br from-akarma-blue to-akarma-blue-700 text-white rounded-2xl p-8 md:p-12 text-center">
              <h2 className="text-3xl font-bold mb-4">Toplam Sayfa Sayısı</h2>
              <div className="text-6xl font-bold mb-4">
                {sitemapSections.reduce((total, section) => total + section.links.length, 0)}
              </div>
              <p className="text-xl opacity-90 mb-8">
                akarma.com.tr web sitesinde toplam {sitemapSections.reduce((total, section) => total + section.links.length, 0)} sayfa bulunmaktadır.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                  <div className="text-3xl font-bold mb-2">5</div>
                  <div className="text-sm opacity-90">Ana Kategori</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                  <div className="text-3xl font-bold mb-2">3</div>
                  <div className="text-sm opacity-90">Makale</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                  <div className="text-3xl font-bold mb-2">100%</div>
                  <div className="text-sm opacity-90">SEO Uyumlu</div>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-12 text-center">
              <p className="text-xl text-gray-700 mb-6">
                Aradığınız sayfayı bulamadınız mı?
              </p>
              <Link
                to="/iletisim"
                className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white rounded-full font-semibold hover:shadow-lg transition-all duration-300"
              >
                Bizimle İletişime Geçin
                <ChevronRight size={20} className="ml-2" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Sitemap;